import React from 'react';

export const Home = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2719_2216)">
      <path
        d="M13.3334 2H8.00004C7.63337 2 7.33337 2.3 7.33337 2.66667V3.74C7.33337 3.74 7.33337 3.74 7.34004 3.74667L10.6734 6.74667C11.0934 7.12 11.3334 7.66667 11.3334 8.23333V8.66667H12.6667V10H11.3334V11.3333H12.6667V12.6667H11.3334V14H13.3334C13.7 14 14 13.7 14 13.3333V2.66667C14 2.3 13.7 2 13.3334 2ZM10 4.66667H8.66671V3.33333H10V4.66667ZM12.6667 7.33333H11.3334V6H12.6667V7.33333ZM12.6667 4.66667H11.3334V3.33333H12.6667V4.66667Z"
        fill="#297FFF"
      />
      <path
        d="M10 13.3333V8.23332C10 8.04665 9.92 7.86665 9.78 7.73998L6.44667 4.73998C6.32 4.61998 6.16 4.56665 6 4.56665C5.84 4.56665 5.68 4.62665 5.55333 4.73998L2.22 7.73998C2.08 7.85998 2 8.03998 2 8.23332V13.3333C2 13.7 2.3 14 2.66667 14H4C4.36667 14 4.66667 13.7 4.66667 13.3333V10.6667H7.33333V13.3333C7.33333 13.7 7.63333 14 8 14H9.33333C9.7 14 10 13.7 10 13.3333Z"
        fill="#15B79E"
      />
    </g>
    <defs>
      <clipPath id="clip0_2719_2216">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
